import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import {
	ContentTypesHeaderQuery,
	type ContentTypesHeaderQuery$data,
	type ContentTypesHeaderQuery$variables,
} from '@confluence/content-types-utils/entry-points/ContentTypesHeaderQuery.graphql.ts';
import { expVal } from '@confluence/feature-experiments';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadContentTypesHeader(contentId: string): Promise<{
	data: ContentTypesHeaderQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<ContentTypesHeaderQuery$data, ContentTypesHeaderQuery$variables>({
		query: ContentTypesHeaderQuery,
		variables: {
			contentId,
		},
	}).then((result) => {
		if (expVal('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) {
			const contentIsRestrictedBySpacePermissions = result?.errors?.find(
				(e) => e?.path?.[0] === 'content' && e?.message?.includes('Space is restricted'),
			);

			window['__SPACE_RESTRICTED_ERROR__'] = contentIsRestrictedBySpacePermissions
				? contentId
				: null;
		}

		return result;
	});
}
